import Api from "@/services/api";

export const getSearch = async (query: string) => {
    return await Api.get('/search?' + query)
}
